import t from '@rcm/i18n-client';
import React, { useMemo } from 'react';
import { Navbar } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import useProductQueries from '../../hooks/useProductQueries';
import { selectSkusSelectedQuantities } from '../../slices/skusSelected';

const PVIndicator = () => {
    const productsQueries = useProductQueries();
    const skuQuantities = useSelector(selectSkusSelectedQuantities);
    const pv: number = useMemo(() => (
        productsQueries.data?.map((product) => (
            product.skus.filter((sku) => sku.number in skuQuantities)
        ))
        .reduce((flattened, skus) => [ ...flattened, ...skus], [])
        .reduce((v, sku) => (
            v + ((+sku.pvPrice) * skuQuantities[sku.number])
        ), 0) || 0
    ), [productsQueries, skuQuantities]);

    return <Navbar.Text>{t('PV Total: {pv}', {pv})}</Navbar.Text>
}

export default PVIndicator;
